const LS_KEY = "isp_token_1";
export default function getUserSession() {
    if (LS_KEY in localStorage) {
        return localStorage.getItem(LS_KEY);
    }
    return null;
}
export function setUserSession(key) {
    localStorage.setItem(LS_KEY, key);
}
//# sourceMappingURL=getUserSession.js.map